import { Component, Signal, effect, inject } from '@angular/core';
import { ToastNotification } from '@scenario/models/toast-notification.model';
import { dispatch, select } from '@store/injectables';
import { removeToastByReference } from '@store/toast-notifications/toast-notifications-slice';
import { NotificationService } from '@totalenergiescode/tds-angular';

@Component({
    selector: 'app-toast-displayer',
    templateUrl: './toast-displayer.component.html'
})
export class ToastDisplayerComponent {
  private readonly notificationService = inject(NotificationService);
  dispatch = dispatch();

  toastNotifications: Signal<ToastNotification[]> = select(
    state => state.toastNotifications.toastNotifications,
  );

  constructor() {
    effect(
      () => {
        this.toastNotifications().forEach(notification => {
          this.notificationService.openNotification(notification);
          this.dispatch(removeToastByReference(notification.reference));
        });
      },
    );
  }
}
